import { useCallback } from 'react';
import { shallow } from 'zustand/shallow';

import { IComboboxItem, useComboboxOnChange, useComboBoxStore } from '../../combobox';
import { SLASH_KEY } from '../defaults';

export const useOnSlashChange = (data: any[]) => {
  const comboboxOnChange = useComboboxOnChange({
    key: SLASH_KEY,
    trigger: '/',
  });
  const { maxSuggestions, setItems } = useComboBoxStore(
    // tslint:disable-next-line: no-shadowed-variable
    ({ maxSuggestions, setItems }) => ({
      maxSuggestions,
      setItems,
    }),
    shallow
  );

  return useCallback(
    (editor) => {
      const res = comboboxOnChange(editor);
      if (!res) return false;

      const { search } = res;

      const items: IComboboxItem[] = data
        .filter((c) => c.name.toLowerCase().includes(search.toLowerCase()))
        .slice(0, maxSuggestions)
        .map((item) => ({
          key: item.value,
          text: item.name,
          ...item,
        }));

      setItems(items);

      return true;
    },
    [comboboxOnChange, data, maxSuggestions, setItems]
  );
};
